module.exports = __webpack_public_path__ + "img/peak-logo-new-design.a0035df3.png";